import React from "react";
import { Layers } from "lucide-react";

/**
 * SyllabusProgressHeader
 *
 * Title, subtitle, and overall progress bar.
 *
 * Props:
 *   - totalDays      : Number
 *   - completedDays  : Number
 *   - progressPercent : Number (0-100)
 */
const SyllabusProgressHeader = ({ totalDays, completedDays, progressPercent }) => {
  const allDone = completedDays === totalDays && totalDays > 0;

  return (
    <div className="ss-progress-header">
      {/* Title area */}
      <div className="ss-header-top">
        <h1>Course Syllabus</h1>
        <p>Track your learning progress</p>
      </div>

      {/* Progress bar card */}
      <div className="ss-progress-card">
        <div className="ss-progress-stats">
          <span className="ss-progress-label">
            <Layers size={15} />
            Overall Progress
          </span>
          <span className="ss-progress-value">
            {completedDays} / {totalDays} days completed
          </span>
        </div>
        <div className="ss-progress-bar-wrap">
          <div
            className={`ss-progress-bar-fill ${allDone ? "ss-bar-complete" : ""}`}
            style={{ width: `${progressPercent}%` }}
          />
        </div>
        <div className="ss-progress-percent">{progressPercent}%</div>
      </div>
    </div>
  );
};

export default SyllabusProgressHeader;
